<div class="content-holder">
  <nav mat-tab-nav-bar>
    <a mat-tab-link *ngFor="let link of links"
       [routerLink]="link.path"
       routerLinkActive #rla="routerLinkActive"
       [active]="rla.isActive">
      {{link.label}}
    </a>
  </nav>
  <div class="content">
    <app-no-content *ngIf="noSettingsSelected"
                    details="Please select settings type from the menu above"
                    i18n-details="Settings Dashboard|Select settings type prompt title@@stats-dashboard-select-settings-type-prompt-title"></app-no-content>

    <router-outlet></router-outlet>
  </div>
</div>
